module.exports = __webpack_public_path__ + "static/Sentry-cf06a10f8545af8056c5fca3179da93e.png";